<template>
  <v-container fluid>
    <v-app-bar dense dark fixed top flat color="transparent" style="z-index:20">
      <v-spacer></v-spacer>

      <v-btn
        text
        :class="[onlyActive ? 'primary' : 'grey lighten-2', 'mr-1']"
        tile
        small
        light
        v-if="role !== 'CLIENT'"
        @click="showOnlyActive"
        >Show only Active Advertisers</v-btn
      >
      <v-btn
        text
        :class="[onlyNew ? 'primary' : 'grey lighten-2', 'mr-1']"
        tile
        small
        light
        v-if="role !== 'CLIENT'"
        @click="showOnlyNew"
        >Show only New Advertisers</v-btn
      >
      <v-btn
        text
        class="primary mr-1"
        tile
        small
        v-if="role !== 'CLIENT'"
        :to="{ name: 'dashboard' }"
        style="z-index: 100"
        >Dashboard</v-btn
      >
    </v-app-bar>
    <CustomLink />
    <div class="mb-12" style="max-width:910px">

      <p class="font-weight-bold font-italic ">Banners Portfolio 2.0 update is coming soon</p>
      <p class=" font-italic ">The Portfolio is undergoing a major upgrade, so the selection of designs might currently be limited. In the future, we aim to increase the variety of creations and add more features to make using this tool more convenient for you.</p>
      <p class=" font-italic ">Stay tuned!</p>
    </div>
    <div
      class="banners-wrapper"
      :fit-width="fitWidth"
      transition-duration="0.2s"
      item-selector=".banner-element"
      :gutter="24"
      horizontal-order="true"
      v-resize="onResize"
      :style="fitWidth ? 'margin:0 auto' : ''"
    >
    
      <Banner
        column-width="300"
        v-for="(banner, index) in bannersByCat"
        :banner="banner"
        :key="banner._id"
        class="banner-element"
        :counter="index"
        @loaded="reloadItems"
      ></Banner>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Masonry from "masonry-layout";
// import _ from "lodash";
// var debounce = require("lodash");

export default {
  name: "BannersHome",
  components: {
    Banner: () => import("@/components/BannerElement"),
    CustomLink: () => import("@/components/CategoryLink"),
  },
  data() {
    return {
      isLoading: true,
      wrapperWidth: null,
      wrapperElement: null,
      bannerWidth: null,
      onlyActive: false,
      onlyNew: false,
      windowSize: { x: 0, y: 0 },
      fitWidth: true,
      msnry: null,
    };
  },

  mounted() {
    // this.debouncedRedraw = _.debounce(this.redraw, 50);
    // await this.fetchBanners();
    this.msnry = new Masonry(".banners-wrapper", {
      // options
      itemSelector: ".banner-element",
      gutter: 24,
      horizontalOrder: true,
      // transitionDuration: '0.2s'
    });
  },
  methods: {
    reloadItems() {
      this.msnry.reloadItems();
      this.msnry.layout();
    },
    // ...mapActions(["fetchBanners"]),
    layoutComplete() {
      console.log("comlete");
    },
    onResize() {
      this.fitWidth = window.innerWidth < 1080;
    },
    // redraw() {
    //   this.$redrawVueMasonry("1");
    // },
    showOnlyActive() {
      this.onlyActive = !this.onlyActive;
    },
    showOnlyNew() {
      this.onlyNew = !this.onlyNew;
    },
    sortByName(a, b) {
      const bandA = a.company.name;
      const bandB = b.company.name;
      if (bandA < bandB) {
        return -1;
      }
      if (bandA > bandB) {
        return 1;
      }
      return 0;
    },
  },
  // watch: {
  //   bannersByCat: {
  //     handler: function() {
  //       this.$nextTick(this.debouncedRedraw);
  //       setTimeout(this.debouncedRedraw, 1500);
  //     },
  //     deep: true,
  //   },
  //   fitWidth() {
  //     this.debouncedRedraw();
  //   },
  // },
  // activated() {
  //   this.redraw();
  // },
  watch: {
    bannersByCat() {
      setTimeout(this.reloadItems, 1);
    },
  },
  computed: {
    ...mapGetters(["viewID", "banners", "topCategories", "role"]),
    ...mapState(["banner", "category"]),
    bannersByCat() {
      // const query = this.banner.searchQuery.toLowerCase();
      const tagQuery = this.banner.tagQuery;

      const selectedCategories = this.category.activeCategories || [];
      let helperCat = [...this.topCategories];
      helperCat.forEach((helper) =>
        helper.categories.forEach(
          (helpSub) =>
            (helpSub.selected = selectedCategories.includes(helpSub._id))
        )
      );
      helperCat = helperCat.filter((hc) =>
        hc.categories.some((hcs) => hcs.selected)
      );

      let filteredBanners = [...this.banners];
      if (selectedCategories.length > 0 && filteredBanners.length > 0) {
        filteredBanners = filteredBanners.filter(
          (banner) =>
            banner.categories &&
            helperCat.every((hCat) =>
              hCat.categories.some(
                (subCat) =>
                  banner.categories.includes(subCat._id) && subCat.selected
              )
            )
        );
      }

      // if (query) {
      //   filteredBanners = filteredBanners.filter(
      //     (item) =>
      //       item.company.name.toString().toLowerCase().indexOf(query) !== -1 ||
      //       (item.tags || "").toString().toLowerCase().indexOf(query) !== -1
      //   );
      // }
      if (tagQuery.length > 0) {
        filteredBanners = filteredBanners.filter((item) => {
          const substring = (item.tags || "").toLowerCase();
          const match = tagQuery.every((element) => {
            return substring.length > 0 && substring.indexOf(element) > -1;
          });
          return match;
        });
      }

      if (this.onlyActive) {
        filteredBanners = filteredBanners.filter(
          (item) => item.company.panelStatus == true
        );
      }
      if (this.onlyNew) {
        filteredBanners = filteredBanners.filter(
          (item) => item.company.panelStatusText.toLowerCase() == "new"
        );
      }

      const promotedBanners = filteredBanners
        .filter((banner) => banner.promote == true)
        .sort(this.sortByName);
      const banners = filteredBanners
        .filter((banner) => banner.promote != true)
        .sort(this.sortByName);

      const bnrs = [...promotedBanners, ...banners];
      return bnrs;
    },
    columnsCount() {
      const count = (this.wrapperWidth / 600) | 0;
      return count > 0 ? count : 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.banners-wrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  // margin: 0 auto;
}

.banners-container {
  width: 100%;
}

@media only screen and (max-width: 640px) {
  .banners-wrapper {
    margin-top: 0;
  }

  .banners-container {
    padding: 0;
    width: 100%;
  }
}
</style>
